// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"1133108f","193":"d7abaaca","196":"773c075d","358":"8fe64342","659":"f54d1c0e","693":"a677af8b","715":"3f83fe51","719":"93592c73","749":"411e052c","970":"c02dd8d5","978":"b7065420"}[chunkId] + ".chunk.js";
};